import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Card/Card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Skeleton/Skeleton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/styled-engine/esm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Container/createContainer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/createBox/createBox.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/cssVars/createCssVarsProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Grid/createGrid.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/RtlProvider/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/Stack/createStack.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/system/esm/useTheme/useTheme.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/useThemeProps/useThemeProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/system/esm/useThemeWithoutDefault/useThemeWithoutDefault.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common-controls/collette-paragraph-skeleton/collette-paragraph-skeleton.tsx");
